(() => {
  const initialize = (root = document) => {
    const videos = root.querySelectorAll('.tw-product-reels__video:not([data-tw-reel-ready])');
    if (!videos.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.preload = 'metadata';
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '300px 0px', threshold: 0.05 }
    );

    videos.forEach((video) => {
      video.dataset.twReelReady = 'true';
      observer.observe(video);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
